import * as R from 'ramda'
import mergeConfig from 'coact/config/mergeConfig'

import orderViewClientConfig from './orderView/clientConfig.js'
import itemsClientConfig from './items/clientConfig.js'

const config = mergeConfig(
  R.assocPath(
    ['models', 'purchaseOrders', 'views', 'order'],
    orderViewClientConfig,
    {},
  ),
  R.assocPath(['models', 'purchaseOrderItems'], itemsClientConfig, {}),
)

export default fullConfig => mergeConfig(fullConfig, config)
